<template>
    <DCard padding>
        <HeroldLocationForm
            :herold-location-settings="heroldLocationSetting"
            :errors="errors"
            @submit-form="submitData"
        />
    </DCard>
</template>

<script setup>
import HeroldLocationForm from '~@/Components/Settings/HeroldLocationSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    heroldLocationSetting: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const submitData = (form) => {
    form.post(route('settings.herold-location-settings.store'))
}

</script>

<style scoped lang="scss">

</style>
